<template>
  <BasePageContainer class="mandala-evaluations-export pt-10">
    <SettingHeader>チャート一括出力</SettingHeader>
    <MonthPickerWithArrow v-model="selectedYearMonthDate" />
    <CaptionText>※出力する対象の月を選択してください</CaptionText>
    <LabelText>出力するメンバーの選択</LabelText>
    <CaptionText>※出力するメンバーを保存することができます</CaptionText>
    <template v-for="department in accessibleDepartments">
      <DepartmentMemberCheckboxList
        v-if="membersByDepartmentId[department.id]"
        :key="department.id"
        v-model="selectedMemberIds"
        :members="membersByDepartmentId[department.id]"
        :department="department" />
    </template>
    <ButtonsWrapper>
      <template #leftTop>
        <BaseButton
          color="cancel"
          @click="$router.go(-1)">
          キャンセル
        </BaseButton>
      </template>
      <template #rightTop>
        <BaseButton
          @click="onClickExport">
          出力する
        </BaseButton>
      </template>
    </ButtonsWrapper>
    <YesNoCancelConfirmModal
      v-model="isShowConfirmModal"
      @yes="exportMandalaEvaluations(true)"
      @no="exportMandalaEvaluations(false)">
      出力するメンバーリストを保存しますか？
    </YesNoCancelConfirmModal>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import MonthPickerWithArrow from '@/components/parts/MonthPickerWithArrow.vue'
import LabelText from '@/components/parts/LabelText.vue'
import CaptionText from '@/components/parts/CaptionText.vue'
import ButtonsWrapper from '@/components/parts/ButtonsWrapper.vue'
import BaseButton from '@/components/parts/BaseButton.vue'
import DepartmentMemberCheckboxList from '@/components/view/DepartmentMemberCheckboxList.vue'
import { mapState } from 'vuex'
import { format, startOfMonth } from 'date-fns'
import groupBy from 'lodash/groupBy'
import YesNoCancelConfirmModal from '@/components/parts/YesNoCancelConfirmModal.vue'
export default {
  components: {
    SettingHeader,
    MonthPickerWithArrow,
    LabelText,
    CaptionText,
    ButtonsWrapper,
    BaseButton,
    DepartmentMemberCheckboxList,
    YesNoCancelConfirmModal
  },
  data() {
    return {
      members: [],
      selectedYearMonthDate: startOfMonth(new Date()),
      savedMemberIdsResults: [],
      selectedMemberIds: [],
      isShowConfirmModal: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    accessibleDepartments() {
      if (!this.user) return []
      return this.user.accessibleDepartments
    },
    selectedYearMonthStr() {
      return format(this.selectedYearMonthDate, 'yyyy-MM-dd')
    },
    membersByDepartmentId() {
      return groupBy(this.members, member => member.department?.id)
    },
    hasSavedMemberIds() {
      return this.savedMemberIdsResults.length !== 0
    }
  },
  async created() {
    this.$store.commit('startLoading')
    const [members, savedMemberIdsResults] = await Promise.all([
      this.fetchMembers(),
      this.fetchSavedMemberIds()
    ])
    this.setData(members, savedMemberIdsResults)

    this.$store.commit('finishLoading')
  },
  methods: {
    setData(members, savedMemberIdsResults){
      this.members = members
      this.savedMemberIdsResults = savedMemberIdsResults
      const memberIds = members.map(member => member.id)
      this.selectedMemberIds = savedMemberIdsResults.length !== 0 ? savedMemberIdsResults[0].userIds.filter(id => memberIds.includes(id)) : []
    },
    fetchMembers() {
      return this.$axios.get('/users/', {
        params: {
          ordering: '-sort_no',
          limit: 999999,
        }
      }).then((res) => {
        return res.data.results
      })
    },
    onClickExport() {
      if (this.selectedMemberIds.length === 0) {
        this.$store.commit('notify/set', { message: 'メンバーが選択されていません', type: 'danger' })
        return
      }
      this.isShowConfirmModal = true
    },
    async exportMandalaEvaluations(isYes) {
      if (isYes) {
        if (this.hasSavedMemberIds) {
          await this.updateSavedMemberIds(this.savedMemberIdsResults[0].id)
        } else {
          await this.postSavedMemberIds()
        }
      }
      this.$store.commit('exportMandalaEvaluations/setSelectedMemberIds', this.selectedMemberIds)
      this.$router.push({
        path: '/admin/mandala_evaluations_export/preview',
        query: {
          yearMonth: this.selectedYearMonthStr,
        }
      })
    },
    fetchSavedMemberIds() {
      return this.$axios.get('/mandala_goal_self_evaluations/output_user_ids/', {
        params: {
          limit: 99999
        }
      }).then(res => {
        return res.data.results
      })
    },
    postSavedMemberIds() {
      return this.$axios.post('/mandala_goal_self_evaluations/output_user_ids/', {
        user_ids: this.selectedMemberIds
      })
    },
    updateSavedMemberIds(id) {
      return this.$axios.patch(`/mandala_goal_self_evaluations/output_user_ids/${id}/`, {
        user_ids: this.selectedMemberIds
      })
    },
  }
}
</script>

<style>

</style>